import {useEffect} from 'react';
import {usePurchaseContext} from './PurchaseProvider';
import {useAccountVerifyLogin} from '@/hooks';
import {PurchaseContextProps} from './types';
import {useLocale} from '@epic-mw/i18n';
import {getSandboxId} from '@/lib/utils/purchase.utils';

export const PurchaseConfirmAuth = () => {
	const locale = useLocale();
	const {offerId, sandboxId, state: purchaseState, ...context} = usePurchaseContext();
	const {verifyAuthenticated} = useAccountVerifyLogin(locale);

	useEffect(() => {
		if (purchaseState === 'confirmAuth') {
			const {actions} = context as PurchaseContextProps<'confirmAuth'>;
			if (
				verifyAuthenticated({
					redirectUrlParams: {
						purchaseIntentId: getSandboxId({offerId, namespace: sandboxId})
					}
				})
			) {
				actions.confirmAuth.next?.();
			}
		}
	}, [context.actions, verifyAuthenticated, purchaseState]);

	return null;
};
